import React from "react"
import Select from "react-select"
import { connectField } from "uniforms"
import { operatingHoursValues } from "../../../api/places/operatingHoursModel"

class OperatingHoursInput extends React.Component {
  onOpenChange = (option?: { value?: string }) => {
    if (option && option.value !== undefined) {
      const newOpenTime = option.value
      this.props.onChange(newOpenTime, `${this.props.name}.openTime`)

      const closeTime = this.props.value.closeTime
      if (closeTime === undefined) {
        this.props.onChange(newOpenTime, `${this.props.name}.closeTime`)
      }
    } else {
      this.props.onChange({}, `${this.props.name}`)
    }
  }

  onCloseChange = (option?: { value?: string }) => {
    if (option && option.value !== undefined) {
      const newCloseTime = option.value
      this.props.onChange(newCloseTime, `${this.props.name}.closeTime`)
    } else {
      this.props.onChange({}, `${this.props.name}`)
    }
  }

  // Convert primitive values to option objects for react-select v5
  getSelectedOption = primitiveValue => {
    if (primitiveValue !== null && primitiveValue !== undefined && primitiveValue !== "") {
      return operatingHoursValues.find(opt => opt.value === primitiveValue) || null
    }
    return null
  }

  render() {
    const { id, label, name, value } = this.props

    // Common styles for both selects
    const selectStyles = {
      input: provided => ({
        ...provided,
        border: "none",
        padding: 0,
        margin: 0,
        boxShadow: "none",
        background: "transparent",
      }),
      container: provided => ({
        ...provided,
        minWidth: "140px",
        width: "140px",
      }),
      control: provided => ({
        ...provided,
        minWidth: "140px",
        width: "140px",
      }),
      valueContainer: provided => ({
        ...provided,
        padding: "2px 8px",
      }),
      menu: provided => ({
        ...provided,
        zIndex: 9999,
        minWidth: "140px",
      }),
      menuPortal: provided => ({
        ...provided,
        zIndex: 9999,
      }),
    }

    return (
      <div
        className="day-group"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "8px",
          minWidth: "420px",
          width: "100%",
          maxWidth: "600px",
        }}
      >
        {label && (
          <label
            htmlFor={id}
            style={{
              minWidth: "90px",
              width: "90px",
              textAlign: "right",
              marginRight: "15px",
              flexShrink: 0,
            }}
          >
            {label}
          </label>
        )}

        <Select
          name={`${name}.openTime`}
          value={this.getSelectedOption(value.openTime)}
          placeholder="Closed"
          options={operatingHoursValues}
          className="time-input open-time"
          classNamePrefix="cl-select"
          onChange={this.onOpenChange}
          styles={selectStyles}
          menuPortalTarget={document.body}
        />

        <Select
          name={`${name}.closeTime`}
          value={this.getSelectedOption(value.closeTime)}
          placeholder=""
          options={operatingHoursValues}
          className="time-input close-time"
          classNamePrefix="cl-select"
          onChange={this.onCloseChange}
          disabled={value.openTime === undefined}
          styles={selectStyles}
          menuPortalTarget={document.body}
        />
      </div>
    )
  }
}

export default connectField(OperatingHoursInput)
